import { render } from "./SimpleCoinMain.vue?vue&type=template&id=2b686be0&scoped=true"
import script from "./SimpleCoinMain.vue?vue&type=script&lang=js"
export * from "./SimpleCoinMain.vue?vue&type=script&lang=js"

import "./SimpleCoinMain.vue?vue&type=style&index=0&id=2b686be0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b686be0"]])

export default __exports__